/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCart} from '../api'

 export const useQueryGetCart = createReactQueryHook('getCart', getCart)
